// @flow
import * as React from 'react';

import { useDispatch } from 'react-redux';
import { useParams } from 'react-router-dom';

import { fetchCartOwnerList } from '@gandi/cart';

import type { Role } from '../types';

import type { Response } from './useHandleFormError';

export function useExistingAccountAction({
  role,
  setCurrentRadioValue,
}: {
  role?: Role,
  setCurrentRadioValue?: React.ReactSetStateFunction<?string>,
}): {
  existingAccountAction: (resp: Response, id: string) => Promise<void>,
} {
  const dispatch = useDispatch();
  const params = useParams<{ cartId: string }>();

  const existingAccountAction = async (resp: Response, id: string) => {
    if (resp.data.id && typeof setCurrentRadioValue === 'function') {
      setCurrentRadioValue(id);
    }

    if (role === 'BILLING') {
      await dispatch(fetchCartOwnerList(params.cartId));
    }
  };

  return { existingAccountAction };
}
